export const SKIPPED_ENABLE_ALL_MARKETPLACES_KEY =
  'skippedEnableAllMarketplacesDate'

export const SELECTED_MARKETPLACE_KEY = 'selected-marketplace'
export const SELECTED_ACCOUNT_MARKETPLACE_KEY = 'SELECTED_AMAZON_MARKETPLACE'
